const version = '0.1.27';

export default version;



/** WEBPACK FOOTER **
 ** ./src/api/version.js
 **/